<template>
	<div class>
		<v-layout row wrap>
			<v-flex lg12 md12>
				<v-container fluid>
					<v-form
						@submit.prevent="editCorporateMember()"
						ref="form"
						v-model="valid"
						lazy-validation
					>
						<br />
						<v-card flat>
							<v-container fluid>
								<v-layout row wrap>
									<v-flex lg4 md4 sm12 xs12>
										<v-container>
											<v-text-field label="Member ID" v-model="member.member_id" required >
												
											</v-text-field>
										</v-container>
									</v-flex>

									<v-flex lg4 md4 sm12 xs12>
										<v-container>
											<v-dialog
												ref="dialog2"
												persistent
												v-model="modal2"
												lazy
												full-width
												width="290px"
												:return-value.sync="member.expiry_date"
											>
												<v-text-field
													slot="activator"
													label="Membership Expiry Date"
													v-model="member.expiry_date"
													:rules="requiredRules"
													readonly
												></v-text-field>
												<v-date-picker v-model="member.expiry_date" scrollable>
													<v-spacer></v-spacer>
													<v-btn
														:depressed="true"
														flat
														color="primary"
														@click="modal2 = false"
													>Cancel</v-btn>
													<v-btn
														:depressed="true"
														flat
														color="primary"
														@click="$refs.dialog2.save(member.expiry_date)"
													>OK</v-btn>
												</v-date-picker>
											</v-dialog>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12>
										<v-container>
											<v-text-field
												v-model="member.company_name"
												:rules="requiredRules"
												label="Company Name"
												required
											></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12>
										<v-container>
											<v-text-field
												v-model="member.contact_person_name"
												:rules="requiredRules"
												label="Contact Person Name"
												required
											></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12>
										<v-container>
											<v-text-field
												v-model="member.postal_address"
												:rules="requiredRules"
												label="Postal Address"
												required
											></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12>
										<v-container>
											<v-text-field
												v-model="member.postal_code"
												:rules="requiredRules"
												label="Postal Code"
												required
											></v-text-field>
										</v-container>
									</v-flex>
									
									<v-flex lg4 md6 sm12 xs12>
										<v-container>
											<v-autocomplete
												label="Country"
												v-model="member.code"
												:items="allCountries"
												:rules="[v => !!v || 'Country is required']"
												required
												item-text="name"
												item-value="code"
												@change="findCountryCode"
												:loading="$loadingTrue"
											></v-autocomplete>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12>
										<v-container>
											<v-text-field
												v-model="member.phone_number"
												:rules="requiredRules"
												label="Company Phone Number (e.g. +XXX...)"
												required
												minlength="13"
												type="text"
											></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12>
										<v-container>
											<v-text-field
												v-model="member.contact_person_phone_number"
												:rules="requiredRules"
												label="Contact Phone Number (e.g. +XXX...)"
												required
												minlength="13"
												type="text"
											></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12>
										<v-container>
											<v-text-field
												v-model="member.town"
												:rules="requiredRules"
												label="Town/City"
												required
												type="text"
											></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg4 md5 sm12 xs12>
										<v-container>
											<v-select
												label="Payment Method"
												v-model="member.payment_method"
												:items="['Mpesa', 'Credit Card','Bank Transfer','Cheque','Voucher']"
												required
												:loading="$loadingTrue"
											></v-select>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12>
										<v-container>
											<v-text-field
												label="Amount Paid"
												v-model="member.amount"
												required
												type="number"
											></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12>
										<v-container>
											<v-text-field
												label="No of Vechicles"
												v-model="member.vehicles"
												required
												type="number"
											></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12>
										<v-container>
											<v-text-field
												label="No of Passengers"
												v-model="member.passengers"
												required
												type="number"
											></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12>
										<v-container>
											<v-text-field
												label="No of Visits per Year"
												v-model="member.visits"
												required
												type="number"
											></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12>
										<v-container>
											<v-text-field
												label="Salesforce Opportunity ID"
												v-model="member.salesforce_uuid"
												required
											></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12>
										<v-container>
											<v-text-field
												label="Salesforce Contact ID"
												v-model="member.salesforce_contact_uuid"
												required
											></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12>
										<v-container>
											<v-text-field
												label="Salesforce Account ID"
												v-model="member.salesforce_account_uuid"
												required
											></v-text-field>
										</v-container>
									</v-flex>
										<v-flex lg4 md4  sm12 xs12><v-container>
										<v-text-field
											v-model="member.email"
											:rules="requiredRules"
											label="Email"
											required
											type="email"
										></v-text-field>
									</v-container></v-flex>
									<v-flex lg4 md4  sm12 xs12><v-container>
										<v-text-field
											v-model="member.email1"
											label="Another Email"
											type="email"
										></v-text-field>
									</v-container></v-flex>
									<v-flex lg4 md4  sm12 xs12><v-container>
										<v-text-field
											v-model="member.email2"
											label="Another Email"
											type="email"
										></v-text-field>
									</v-container></v-flex>
								</v-layout>
								 {{ updateCorporateMember }}
							</v-container>
							
							<br />
							<v-container>
								<v-switch
									color="primary"
									label="Is Paid"
									v-model="member.payment_status"
									required
								></v-switch>
							</v-container>
							<!-- <v-container>
								<v-switch color="primary" label="Is Paid" v-model="member.payment_status" required></v-switch>
							</v-container> -->
							<v-btn :depressed="true" color="primary" type="submit">UPDATE INFO</v-btn>
						</v-card>
					</v-form>
				</v-container>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
export default {
	name: "EditCorporateMember",
	data() {
		return {
			start_date: this.$moment()
				.subtract(18, "years")
				.format("YYYY-MM-DD"),
			requiredRules: [v => !!v || "This field is required"],
			emailRules: [
				v => !!v || "E-mail is required",
				v => /.+@.+/.test(v) || "E-mail must be valid"
			],
			valid: true,
			menu1: false,
			modal1: false,
			modal2: false,
			dialogED: false,
			modalED: false,
			dob_config: {
				maxDate: this.$moment()
					.subtract(18, "years")
					.format("YYYY-MM-DD")
			},
			dob_config2: {
				maxDate: "today"
			},
			member: {
				member_id: "",
				company_name: "",
				email: "",
				email1:"",
				email2:"",
				phone_number: "",
				contact_person_name: "",
				contact_person_phone_number: "",
				salesforce_uuid: "",
				postal_address: "",
				postal_code: "",
				salesforce_contact_uuid: "",
				salesforce_account_uuid: "",
				expiry_date: "",
				payment_status: "",
				payment_method: "",
				amount: "",
				town: "",
				country: "",
				code: "",
				passengers: "",
				vehicles: "",
				visits: "",
				redirect_url: "CorporateMember"
			},
			residence: {},
			existing_member: false,
			household: false
		};
	},
	created() {
		this.$store.dispatch("get_all_countries");
		this.$store.dispatch("get_all_membership_settings");
		this.$store.dispatch("get_all_genders");
		this.$store.dispatch("get_all_residence_types");
		this.$store.dispatch("get_all_house_holds");
	},
	methods: {
		findCountryCode(data) {
			var instance = this;
			this.allCountries.map(function(country) {
				if (data === country.code) {
					instance.member.tel_number = "+" + country.calling_code;
				}
			});
		},
		getResidence: function(data) {
			this.residence = data;
			this.member.member_setting = this.residence.public_id;
			this.$store.commit("GET_LOCAL_MEMBERS", this.residence);
		},
		editCorporateMember() {
			this.$store.dispatch("update_corporate_member", this.member);
		}
	}
};
</script>

<style scoped>
</style>
